import { render } from "./BuyFund.vue?vue&type=template&id=4077e918&scoped=true"
import script from "./BuyFund.vue?vue&type=script&lang=js"
export * from "./BuyFund.vue?vue&type=script&lang=js"

import "./BuyFund.vue?vue&type=style&index=0&id=4077e918&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4077e918"]])

export default __exports__